import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Select, Input } from 'loyal-react'
import ValueRechargeClient from './ValueRechargeClient'

class ValuesRecharge extends Component {
  constructor (props) {
    super(props)
    this.state = { valuesRecharge: [] }

    this.onChange = this.onChange.bind(this)
    this.successListValueRecharge = this.successListValueRecharge.bind(this)
    this.loadValuesRecharge = this.loadValuesRecharge.bind(this)
    this.successListValueRecharge = this.successListValueRecharge.bind(this)
  }

  loadValuesRecharge () {
    if (!this.props.operatorKey || !this.props.areaCode) {
      this.setState({ valuesRecharge: [] })
    }
    ValueRechargeClient.listValuesRecharge(
      this.props.operatorKey,
      this.props.areaCode,
      this.successListValueRecharge
    )
  }

  successListValueRecharge (data) {
    data.forEach(
      item =>
        (item.descriptionMoneyValue = `R$ ${this.handleFormatValue(
          item.rechargeValue,
          2
        )}`)
    )
    this.setState({ valuesRecharge: data })
  }

  componentDidUpdate (prevProps) {
    if (
      !prevProps ||
      this.props.operatorKey !== prevProps.operatorKey ||
      this.props.areaCode !== prevProps.areaCode
    ) {
      this.loadValuesRecharge()
    }
  }

  onChange (selectedItem) {
    this.props.onChangeValue(selectedItem)
  }

  handleFormatValue = (value, decimal) => {
    if (!isNaN(value)) {
      return `${parseFloat(value).toLocaleString('pt-br', {
        minimumFractionDigits: decimal || this.props.decimalPlaces,
        maximumFractionDigits: decimal || this.props.decimalPlaces
      })}  ${decimal ? '' : this.props.pointsName} `
    }
    return ''
  }

  render () {
    let value = this.state.valuesRecharge.find(
      item => item.serviceId === this.props.serviceId
    )

    return (
      <Fragment>
        <Select
          id='selectCreditValue'
          label='Valor da Recarga'
          className={'col-12 mt-2 form-field'}
          displayValue='descriptionMoneyValue'
          selectedValue='serviceId'
          options={this.state.valuesRecharge}
          value={value || {}}
          onChange={this.onChange}
          key={(value && value.serviceId) || ''}
        />
        <Input
          id='pointsValue'
          label='Você vai gastar'
          className={'col-12 mt-2 form-field'}
          value={this.handleFormatValue(
            `${(value && value.pointsValue) || '0'}`
          )}
          readOnly
        />
      </Fragment>
    )
  }
}

ValuesRecharge.propTypes = {
  areaCode: PropTypes.number.isRequired,
  operatorKey: PropTypes.string,
  onChangeValue: PropTypes.func,
  serviceId: PropTypes.string,
  pointsName: PropTypes.string,
  decimalPlaces: PropTypes.number
}

const mapStateToProps = ({
  catalog: {
    currencyConfiguration: { pointsName, decimalPlaces }
  }
}) => ({
  pointsName,
  decimalPlaces
})

export default connect(
  mapStateToProps,
  null
)(ValuesRecharge)



// WEBPACK FOOTER //
// ./src/features/Services/RechargePhone/FormStep/ValuesRecharge.js